export default __webpack_public_path__ + "files/ded3d3f30da420eacfdb9747ae860b87.mp3";